import * as React from 'react';
import { useSavedFilterErrorMessage } from '@src/components/summary-panel/FilterDropdown/FilterStatus';
import { useAtomValue } from 'jotai';
import { checkInvalidDimension } from '../../utils';
import * as Store from '../store';
import InvalidDimensionWarning, { CUSTOM_TAG_WARNING_CONTENT } from './InvalidDimensionWarning';
import * as Styled from './styled';
import type { FilterRule } from '../../../types';
import { errorDataAtom } from '@src/components/metrics-panel-hz/atoms/index';

const SavedFilterAtom = () => {
  const errorData = useAtomValue(errorDataAtom);
  const [filterValue] = Store.useFilterValue();
  const [filterStatus, setFilterStatus] = Store.useFilterStatus();
  const disabled = Store.useFilterDisabled();
  const meta = Store.useFilterMetaMap();
  const invalidCustomTagFilter = Store.useInvalidCustomTagFilterWarning();
  const message = useSavedFilterErrorMessage();

  const invalidDimension =
    invalidCustomTagFilter ||
    (filterValue.rule.flat(Infinity) as FilterRule[]).some(
      (it) =>
        (meta.size && !meta.get(it.field)) || checkInvalidDimension(it.field, errorData.fields),
    );

  return (
    <Styled.AtomContainer
      $disabled={disabled || filterStatus === 'editing-advanced' || !filterValue.rule.length}
      style={{ display: 'inline-block' }}
      onClick={() => setFilterStatus('editing')}
    >
      {filterValue.name}
      {invalidDimension && (
        <InvalidDimensionWarning
          title={invalidCustomTagFilter ? CUSTOM_TAG_WARNING_CONTENT : message}
          style={{ marginLeft: 4 }}
        />
      )}
    </Styled.AtomContainer>
  );
};

export default React.memo(SavedFilterAtom);
